import script from "./Foot.vue?vue&type=script&lang=ts&setup=true"
export * from "./Foot.vue?vue&type=script&lang=ts&setup=true"

import "./Foot.vue?vue&type=style&index=0&id=23ef2dc3&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23ef2dc3"]])

export default __exports__